import { Elements } from '@stripe/react-stripe-js';
import { useContext, useEffect, useState } from 'react';
import { createPaymentStripe } from '../../../stores/payment.store';
import { IStripeClientSecret } from '../../../interfaces';
import CheckoutFormStripe from './checkout-form';
import { MainContext } from '../../../context/main.context';
import { PAYMENTS_STRIPE_CREATE_ERROR } from '../../../common/errorCodes';
import { toast } from 'react-toastify';
import ManualController from '../../../hoc/ManualController';


export default function PaymentsStripe() {
    const [ clientSecret, setClientSecret ] = useState('');
    const [ stripePaymentId, setStripePaymentId ] = useState('');
    const { manualRedirect } = ManualController();
    const { paymentId, toggleLoader } = useContext(MainContext);
    const [ stripe, setStripe ] = useState(null);

    useEffect(() => {
        const script = document.createElement('script');
        script.src = process.env.REACT_APP_STRIPE_SRC as string;
        script.async = true;
        script.onload = () => {
            setStripe(window.Stripe(process.env.REACT_APP_PUBLIC_STRIPE_PUBLISHABLE_KEY));
            _createPayment();
        };

        document.body.appendChild(script);

        return () => {
            window.Stripe = null;
            document.body.removeChild(script);
        };
    }, []);

    const _createPayment = (): void => {
        toggleLoader(true);

        createPaymentStripe(paymentId).then(res => {
            const result = res.data.clientSecret && res.data.id;

            if (result) {
                setClientSecret(res.data.clientSecret);
                setStripePaymentId(res.data.id);
                return;
            }

            toast.error('CREATE_PAYMENT_STRIPE_ERROR');
        }, err => {
            const errData = err?.response?.data || err;
            manualRedirect(errData, 'payment', true, PAYMENTS_STRIPE_CREATE_ERROR);
        }).finally((): void => {
            toggleLoader(false);
        });
    }

    if (!clientSecret) {
        return null;
    }

    const options: IStripeClientSecret = {
        clientSecret,
        appearance: {
            theme: 'flat',
            variables: {
                iconCloseColor: 'red'
            }
        },
        layout: {
            type: 'accordion',
            defaultCollapsed: false,
            radios: false,
            spacedAccordionItems: true,

        }
    };

    return (
        <Elements stripe={stripe} options={options}>
            <CheckoutFormStripe stripePaymentId={stripePaymentId} paymentId={paymentId}/>
        </Elements>
    );
}

PaymentsStripe.displayName = 'PaymentsStripe';